import { Flex, Modal, Row, Timeline, Tooltip, Typography } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import iconGlobal from '../../assets/images/ic-global.svg';
import iconImage from '../../assets/images/ic-image.svg';
import ModalLocationShow from '../../components/Modal/ModalLocationShow';
import { useAppSelector } from '../../redux/hooks';
import { listColor } from '../../utils/listColorItem';

function BookingScheduleModal({ okText, cancelText, modalOpen, onOk, onCancel, formSearch }: any) {
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const { listDetailScheduleBooking } = useAppSelector((state) => state.listBooking);
  const [isShowList, setIsShowList] = useState(false);
  const [listImage, setListImage] = useState([]);
  const [segmentTimelineItem, setSegmentTimelineItem] = useState<any>([]);

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };

  const modalHandleCancel = () => {
    onCancel();
  };
  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);
  const cancelShowList = () => {
    setIsShowList(false);
  };
  useEffect(() => {
    if (listDetailScheduleBooking?.length) {
      const timelineItems = listDetailScheduleBooking?.map((scheduleItem: any, index: number) => ({
        children: (
          <div key={`schedule-${index}`} className="block-bg-color items-center">
            <Flex>
              <div className={`btn-time-line ${listColor[(index + 1) % listColor?.length]}`}>
                {`${scheduleItem?.name ? scheduleItem?.name : ''} `}
              </div>
            </Flex>
            {scheduleItem?.transships?.length &&
              scheduleItem?.transships?.map((transship: any, tIndex: number) => (
                <Flex key={`transship-${tIndex}`} gap={8} className="mt-3">
                  <p
                    className={`hour-time-line color ${listColor[(index + 1) % listColor?.length]}`}
                    style={{ width: '50px' }}
                  >
                    {transship?.pickup_time?.slice(0, 5)}
                  </p>
                  <div className="fs-16 fw-500 detail-schedule">
                    <p className="d-flex items-center gap-x-2">
                      {`${transship?.name} (${dayjs()
                        .add(transship?.diff_day || 0, 'day')
                        .format('DD/MM/YYYY')})`}
                      {transship?.images?.length ? (
                        <img
                          src={iconImage}
                          style={{ marginLeft: '3px' }}
                          alt=""
                          className={`img-location-btn`}
                          onClick={() => {
                            setListImage(transship?.images);
                            setIsShowList(true);
                          }}
                        />
                      ) : (
                        <Tooltip
                          title="Vui lòng cập nhật ảnh vào điểm đón trả, văn phòng"
                          key={`img1-${tIndex}`}
                          placement="right"
                        >
                          <img
                            src={iconImage}
                            style={{ marginLeft: '3px' }}
                            alt=""
                            className="img-location-btn disabled"
                          />
                        </Tooltip>
                      )}

                      {transship?.map_link ? (
                        <a
                          href={transship.map_link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginLeft: '3px' }}
                        >
                          <img src={iconGlobal} alt="" className="img-location-btn" />
                        </a>
                      ) : (
                        <Tooltip
                          title="Vui lòng cập nhật link google map vào điểm đón trả, văn phòng"
                          key={`map1-${tIndex}`}
                          placement="right"
                        >
                          <img
                            src={iconGlobal}
                            alt=""
                            className="img-location-btn disabled"
                            style={{ marginLeft: '3px' }}
                          />
                        </Tooltip>
                      )}
                    </p>
                    <span className="description">{transship?.address}</span>
                  </div>
                </Flex>
              ))}
          </div>
        ),
        mode: 'alternate',
        dot: (
          <div className="block-color">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="6" strokeWidth="4" className={listColor[(index + 1) % listColor?.length]} />
            </svg>
          </div>
        ),
      }));

      setSegmentTimelineItem(timelineItems);
    }
  }, [listDetailScheduleBooking, listColor]);

  return (
    <Modal
      open={isModalOpen}
      cancelText={cancelText}
      onCancel={modalHandleCancel}
      onOk={modalHandleOk}
      okText={okText}
      footer={[]}
      width={950}
      maskClosable={false}
      className="booking-schedule-modal scroll-custom-modal"
    >
      <div className="border-booking-title">
        <Typography className="fs-18 fw-600">{'Lịch trình chuyến'}</Typography>
      </div>
      <Row gutter={25} className="detail-schedule-content">
        <Timeline
          className="block-color"
          items={segmentTimelineItem?.length > 0 ? segmentTimelineItem : []}
          style={{ paddingLeft: '20px' }}
        />
      </Row>
      <ModalLocationShow modalOpen={isShowList} onCancel={cancelShowList} onOk={modalHandleOk} listImage={listImage} />
    </Modal>
  );
}
export default BookingScheduleModal;
